import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
import { LoadingController, NavController, Platform } from '@ionic/angular';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiService } from './api.service';
import { AuthService } from './auth.service';
import { environment } from 'src/environments/environment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
pdfMake.vfs = pdfFonts.pdfMake.vfs;


@Injectable({
  providedIn: 'root'
})
export class AppHelperService {
  dayStatus = new BehaviorSubject(false);
  isDayOpen = new BehaviorSubject(false);
  shiftStatus = new BehaviorSubject(false);
  lastSync: any = {};
  dayDetails: any = null;
  settings = {
    appSettings: null,
    curlingSettings: null,
    purchaseSetting: null
  }
  supplier;
  constructor(private storage: Storage, private platform: Platform, private api: ApiService, private auth: AuthService,
    private navcontroller: NavController, private loadingController: LoadingController) {
    this.platform.ready().then(() => {
      // this.previousStatus=ConnectionStatusEnum.Online;
      // this.storage.get(environment.storagekeys.authtoken).then(data=>{
      //   console.log('token',data);
      //   this.authToken=data;
      //   this.tokenStatus.next(true);
      // });
      // this.storage.get(environment.storagekeys.loginDetails).then(data=>{
      //   this.loginUser=data;
      // });
      this.api.tokenStatusCheck().subscribe((data: any) => {
        if (data) {
          // setTimeout(() => {
          this.appSync(false, true);
          // }, 1000);
        }
      })
    });
  }
  async appSync(manual = false, load = false) {
    var loading = await this.loadingController.create({
      message: 'Initializing...',
      spinner: 'bubbles',
      duration: 2000
    });
    if (load) {
      await loading.present();
    }
    // if(this.api.tokenStatus.value!=null){
    if (this.api.authToken != null) {
      this.api.postWtkn('general/sync').subscribe((d: any) => {
        if (d.status) {
          if (!this.lastSync.dayDetails || this.lastSync.dayDetails != d.data.dayDetails) {
            this.api.postWtkn("dayinfo/getDayInfo")
              .subscribe((day: any) => {
                if (day.status) {
                  this.lastSync['dayDetails'] = d.data.dayDetails
                  if (day.data[0]) {
                    this.dayDetails = day.data[0];
                    this.storage.set(environment.storagekeys.dayDetails, day.data[0]);
                    this.isDayOpen.next(!this.dayDetails.isDayClosed)
                  }
                  this.dayStatus.next(true);
                }
              },
                (error) => {
                  // console.log(error);
                })
          }
          if (!this.lastSync.settings || this.lastSync.settings != d.data.settings) {
            if (!this.lastSync.appSettings || this.lastSync.appSettings != d.data.settingsVersions.appSettings)
              this.api.postWtkn("settings/getsettings", { key: "appSettings" })
                .subscribe((settings: any) => {
                  if (settings.status) {
                    this.lastSync['settings'] = d.data.settings
                    if (settings.data) {
                      this.settings.appSettings = settings.data;
                    }
                  }
                },
                  (error) => {
                    // console.log(error);
                  })
            if (!this.lastSync.curlingSettings || this.lastSync.curlingSettings != d.data.settingsVersions.curlingSettings)
              this.api.postWtkn("settings/getsettings", { key: "curlingSettings" })
                .subscribe((settings: any) => {
                  if (settings.status) {
                    this.lastSync['settings'] = d.data.settings
                    if (settings.data) {
                      this.settings.curlingSettings = settings.data;
                    }
                  }
                },
                  (error) => {
                    // console.log(error);
                  })
            if (d.data.settingsVersions.purchaseSetting)//If purchase setting exists then handle purchase settings
              if (!this.lastSync.purchaseSetting || this.lastSync.purchaseSetting != d.data.settingsVersions.purchaseSetting)
                this.api.postWtkn("settings/getsettings", { key: "purchaseSetting" })
                  .subscribe((settings: any) => {
                    if (settings.status) {
                      this.lastSync['settings'] = d.data.settings
                      if (settings.data) {
                        this.settings.purchaseSetting = settings.data;
                      }
                    }
                  },
                    (error) => {
                      // console.log(error);
                    })
          }
          // this.api.postWtkn("suppliers/getSuppliers",{mode:"getSyncData"})
          // .subscribe((supplier:any)=>{
          //   if(supplier.status){
          //     this.supplier= supplier.data;
          //   }
          // },
          // (error)=>{ 
          //   // console.log(error);
          // })
          this.api.postWtkn('auth/checkisactive').subscribe((data: any) => {
            // console.log(data);
            if (!data.status) {
              this.api.setToken(null);
              this.auth.setLoginStatus(false);
              this.storage.clear();
              this.navcontroller.navigateRoot(['/login']);
            }
          })
        }
      })
    }
    if (!manual)
      setTimeout(() => {
        this.appSync();
      }, 30000);
  }
  getDayStatus() {
    return this.dayStatus.asObservable();
  }
  getDayDetails() {
    return (this.dayDetails == null ? null : JSON.parse(JSON.stringify(this.dayDetails)));
  }
  getSettings(key) {
    // console.log(this.settings[key]);
    return (this.settings[key] == null ? null : JSON.parse(JSON.stringify(this.settings[key])));
  }
  async pdfGen(context, options?: {
    pageSize?: 'A3' | 'A4' | 'A5' | 'A6', orientation?: 'landscape' | 'portrait',
    callMode?: 'pdf' | 'print', fileName?: String, pageMargins?, fontSize?, footer?, style?
  }) {
    pdfMake.fonts = {
      Latha: {
        normal: 'Latha.ttf',
        bold: 'Latha.ttf',
        italics: 'Latha.ttf',
        bolditalics: 'Latha.ttf'
      },
      Roboto: {
        normal: 'Roboto-Regular.ttf',
        bold: 'Roboto-Medium.ttf',
        italics: 'Roboto-Italic.ttf',
        bolditalics: 'Roboto-MediumItalic.ttf'
      },
    }
    let ps = options ? (options.pageSize ? options.pageSize : 'A4') : 'A4';
    let po = options ? (options.orientation ? options.orientation : 'portrait') : 'portrait';
    let pm = options ? (options.pageMargins ? options.pageMargins : [10, 20, 10, 20]) : [10, 20, 10, 20]; //[left,top,right,bottom]
    let fontSize = options ? (options.fontSize ? options.fontSize : 14) : 14;
    let footer = options ? (options.footer ? options.footer : {}) : {};
    let style = options ? (options.style ? options.style : {}) : {};
    style['latha'] = {
      font: "Latha"
    };
    const documentDefinition = {
      content: context,
      footer: footer,
      pageSize: ps,
      pageOrientation: po,
      pageMargins: pm,
      defaultStyle: {
        // font: 'Roboto',
        fontSize: fontSize,
      },
      styles: style,
    };
    let filename = options ? (options.fileName ? options.fileName : 'download') : 'download';
    let mode = options ? (options.callMode ? options.callMode : 'print') : 'print';
    var win = window.open('', '_blank');
    switch (mode) {
      case 'pdf':
        pdfMake.createPdf(documentDefinition).download(filename + ".pdf");
        break;
      case 'print':
        await pdfMake.createPdf(documentDefinition).print({}, win);
        break;
      default:
        pdfMake.createPdf(documentDefinition).print({}, win);
        break;
    }
  }
  getLogoDataUrl() {
    return 'data:image/jpeg;base64,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';
  }
}
